var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upload-message" },
    [
      _vm.isLatestMessage
        ? _c("upload-drag-and-drop", {
            attrs: { message: _vm.message },
            on: { submit: _vm.setFiles },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isLatestMessage
        ? _c(
            "button",
            {
              staticClass: "quick-reply-button upload-message__button",
              attrs: { type: "button", disabled: _vm.isButtonDisabled },
              on: { click: _vm.onButtonClick },
            },
            [_vm._v("\n    " + _vm._s(_vm.buttonTitle) + "\n  ")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }